import { UrlMatchResult, UrlSegment } from '@angular/router';

export function noLangSegmentPathMatcher(langs: string[]) {
  return (segments: UrlSegment[]): UrlMatchResult | null => {
    if (segments.length === 0) {
      // for default lang redirector when lang missing
      return { consumed: segments, posParams: undefined };
    }
    if (segments.length > 0 && !langs.includes(segments[0].path)) {
      // for default lang redirector when segments are provided but no lang
      return { consumed: segments, posParams: undefined };
    }
    return null;
  };
}
